import { render, staticRenderFns } from "./QueryRxReport.vue?vue&type=template&id=cbbde1e2&scoped=true&"
import script from "./QueryRxReport.vue?vue&type=script&lang=js&"
export * from "./QueryRxReport.vue?vue&type=script&lang=js&"
import style0 from "./QueryRxReport.vue?vue&type=style&index=0&id=cbbde1e2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbbde1e2",
  null
  
)

export default component.exports